/**
 * SHA-1 of a string → 40-char upper-case hex, via WebCrypto.
 *
 * Used only to build HIBP's Pwned Passwords k-anonymity range key (the first 5
 * hex chars are sent to our proxy; the remaining 35 are matched locally). **SHA-1
 * here is HIBP's index format, not a security primitive** — don't reuse it for
 * anything that needs collision resistance. The password's full hash never
 * leaves the device; see `shared/src/passwordCheckup.ts` and the Phase-2 plan.
 */
export async function sha1Hex(text: string): Promise<string> {
  const data = new TextEncoder().encode(text);
  const digest = await crypto.subtle.digest('SHA-1', data);
  return [...new Uint8Array(digest)]
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
    .toUpperCase();
}
